import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";

export const NoPermission = () => (
  <div className="tr-card mx-auto max-w-lg p-8 text-center" data-testid="no-permission">
    <ShieldOff className="mx-auto mb-3 h-8 w-8 text-[#9bc1ff]" />
    <p className="text-base font-bold text-[#182235]">No tienes permiso para ver esta página</p>
    <p className="mt-1 text-sm text-[#5b667a]">Si crees que es un error, contacta al administrador.</p>
    <Link to="/" className="tr-btn-primary mt-5 px-4 py-2 text-sm" data-testid="no-permission-back">Volver al panel</Link>
  </div>
);
